<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
			<div class="list-opinion fr">
				<el-button type="primary" size="mini" @click="add()" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
			</div>
		</div>
		<el-table :data="list" border size="mini">
			<el-table-column prop="user_name" align="center" :label="$t('system_admin.user')"></el-table-column>
			<el-table-column prop="name" align="center" :label="$t('system_admin.name')"></el-table-column>
			<el-table-column prop="email" align="center" :label="$t('system_admin.email')"></el-table-column>
			<el-table-column prop="role_id" align="center" :label="$t('system_admin.role')" :formatter="role_id_f"></el-table-column>
			<el-table-column prop="seller_info.type" align="center" :label="$t('system_admin.seller_type')" :formatter="seller_type_ff"></el-table-column>
			<!-- <el-table-column prop="country" align="center" :label="$t('system_admin.country')" :formatter="data_rights_f" v-if="is_co==1"></el-table-column> -->
			<el-table-column :label="$t('index.operation')" align="center">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="info" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog :title="$t('index.dialog_title')" width="1000px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
			<el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
				<el-row class="tree-content" :gutter="20">
					<!-- <el-col :span="6" v-if="is_co==1">
						<el-form-item :label="$t('system_admin.country')" prop="country">
							<el-select v-model="editForm.country" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn+$t('index.admin'):item.name+$t('index.admin')" :value="item.code" :key="index" v-for="(item,index) in DATA_RIGHTS"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.user')" prop="user_name">
							<el-input v-model="editForm.user_name" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="editForm.id">
						<el-form-item :label="$t('system_admin.password')" prop="">
							<el-input v-model="password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="!editForm.id">
						<el-form-item :label="$t('system_admin.password')" prop="password">
							<el-input v-model="editForm.password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6" v-if="!editForm.id">
						<el-form-item :label="$t('system_admin.re_password')" prop="re_password">
							<el-input v-model="editForm.re_password" show-password :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="tree-content" :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.name')" prop="name">
							<el-input v-model="editForm.name" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.email')" prop="email">
							<el-input v-model="editForm.email" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.tel')" prop="tel">
							<el-input v-model="editForm.tel" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.role')" prop="role_id">
							<el-select v-model="editForm.role_id" clearable multiple class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="String(item.id)" :key="index" v-for="(item,index) in roleList"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('system_admin.seller_type')" prop="seller_type">
							<el-select v-model="editForm.seller_type" clearable multiple class="w100" :placeholder="$t('index.select')">
								<el-option :label="item" :value="index" v-for="(item,index) in seller_type" :key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="14" v-if="parent_f('seller')">
						<el-form-item :label="$t('system_admin.sale')+$t('system_admin.parent')+$t('system_admin.sale_tishi')" prop="parent_id_seller">
							<el-select v-model="editForm.parent_id_seller" clearable class="w100" :placeholder="$t('index.select')">
								<el-option :label="item.name" :value="item.id" :key="index" v-for="(item,index) in sellerList"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="'佣金比例'" prop="kickback_rate">
							<el-input v-model="editForm.kickback_rate" type="number" :placeholder="$t('index.pleaseInput')" class="w100" auto-complete="off">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="14" v-if="parent_f('director')">
						<el-form-item :label="$t('system_admin.administrators')+$t('system_admin.parent')+$t('system_admin.administrators_tishi')" prop="parent_id">
							<el-select v-model="editForm.parent_id" clearable class="w100" :placeholder="$t('index.select')">
								<el-option :label="item.name" :value="item.id" :key="index" v-for="(item,index) in sellerList"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	computed: {
		rules() {
			return {
				user_name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('system_admin.user'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('system_admin.name'),
					trigger: 'blur'
				}],
				email: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('system_admin.email'),
					trigger: 'blur'
				},{
					type: 'email',
					message: this.$t('index.pleaseInput') + this.$t('system_admin.email_correct'),
					trigger: ['blur', 'change'],
				}],
				role_id: [{
					required: true,
					message: this.$t('index.select') + this.$t('system_admin.role'),
					trigger: 'change'
				}],
				password: [{
					required: true,
					message: this.$t('index.pleaseInput') + this.$t('system_admin.password'),
					trigger: 'blur'
				}],
				// country: [{
				// 	required: true,
				// 	message: this.$t('index.select') + this.$t('system_admin.country'),
				// 	trigger: 'change'
				// }],
			}
		},
		seller_type(){
			return{
				seller:this.$t('system_admin.sale'),
				director:this.$t('system_admin.administrators'),
			}
		}
	},
	data() {
		const validatorEmail = (rule, value, callback) => {
			if (!value) {
				return callback(new Error(this.$t('home.confirm_password')));
			} else {
				if (value == this.editForm.password) {
					callback();
				} else {
					return callback(new Error(this.$t('home.two_passwords')))
				}
			}
		};
		return {
			is_co: sessionStorage.getItem('is_co'),
			list: [],
			editFormVisible: false,
			editForm: {},
			editFormRules: {
				re_password: [{
					required: true,
					trigger: 'blur',
					validator: validatorEmail,
				}],
			},
			password: '',
			filters: {},
			roleList: [], //角色列表
			//DATA_RIGHTS: [], //属于那个国家列表
			sellerList: [], //上级列表
		}
	},
	// 初始事件
	mounted: function () {
		this.editFormRules = Object.assign(this.rules, this.editFormRules);
		this.config();
		this.sellerListNoPage();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			// var url = "getDictionaryValue";
			// var datas = {
			// 	code: "DATA_RIGHTS"
			// };
			// this_.$post(url, datas).then((res) => {
			// 	this_.DATA_RIGHTS = res.DATA_RIGHTS;
			// })
			var url = "roleList";
			this_.$post(url, {}).then((res) => {
				this_.roleList = res;
			})
		},
		sellerListNoPage(){
			var this_ = this;
			var url = "sellerListNoPage";
			var datas = {
				level: 1,
			}
			this_.$post(url, datas).then((res) => {
				this_.sellerList = res;
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "adminList";
			var datas = {};
			this_.$post(url, datas).then((res) => {
				this_.list = res;
			})
		},
		add(data) {
			if (data) {
				var data_data = JSON.parse(JSON.stringify(data));
				var editForm={
					name: data_data.name,
					tel: data_data.tel,
					email:data_data.email,
					user_name: data_data.user_name,
					// country: data_data.country,
					id:data_data.id,
					role_id:data_data.role_id?data_data.role_id.split(','):[],
					seller_type:[],
					parent_id_seller:'',
					parent_id:'',
				}
				if (data_data.seller_info) {
					if (data_data.seller_info.type) {
						editForm['seller_type'] = data_data.seller_info.type.split(',');
					}
					editForm['parent_id_seller'] = data_data.seller_info.parent_id_seller||'';
					editForm['kickback_rate'] = data_data.seller_info.kickback_rate||'';
					editForm['parent_id'] = data_data.seller_info.parent_id||'';
					// editForm['email'] = data_data.seller_info.email||'';
				}
				this.editForm = editForm;
			} else {
				this.editForm = {
					user_name: '',
					// country: '',
					password: '',
					re_password: '',
					role_id:[],
					seller_type:[],
					parent_id_seller:'',
					parent_id:'',
					tel:'',
					email:'',
					name:'',
					kickback_rate:'',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var role_id='';
					if (this_.editForm.role_id&&this_.editForm.role_id.length>0) {
						role_id=this_.editForm.role_id.join(',');
					}
					var seller_type='';
					if (this_.editForm.seller_type&&this_.editForm.seller_type.length>0) {
						seller_type=this_.editForm.seller_type.join(',');
					}
					var datas = {
						user_name: this_.editForm.user_name,
						country:'us',
						role_id: role_id,
						seller_type: seller_type,
						parent_id_seller: this_.editForm.parent_id_seller,
						parent_id: this_.editForm.parent_id,
						tel: this_.editForm.tel,
						email: this_.editForm.email,
						name: this_.editForm.name,
						kickback_rate: this_.editForm.kickback_rate,
					}
					var url = "addUser";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
						url = "changeAdmin";
					} else {
						datas['password'] = this_.editForm.password;
						datas['re_password'] = this_.editForm.re_password;
					}
					if (this_.password && this_.editForm.id) {
						datas['password'] = this_.password;
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.password = '';
						this_.init();
						this_.sellerListNoPage();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "adminDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// data_rights_f(w, s, d) {
		// 	var this_ = this;
		// 	var list = this_.DATA_RIGHTS;
		// 	var name = '';
		// 	list.forEach(function (e, i) {
		// 		if (e.code == d) {
		// 			name = this_.lang == 'cn' ? e.name_cn + this_.$t('index.admin') : e.name + this_.$t('index.admin');
		// 		}
		// 	});
		// 	return name;
		// },
		role_id_f(w, s, d) {
			var this_ = this;
			var list = this_.roleList;
			var return_name = '';
			list.forEach(function (e, i) {
				if (d.indexOf(e.id) != -1) {
					var name = this_.lang == 'cn' ? e.name_cn : e.name;
					return_name == '' ? (return_name = name) : (return_name += name);
				}
			});
			return return_name;
		},
		seller_type_ff(w, s, d) {
			var this_ = this;
			var list = this_.seller_type;
			var name = '';
			if (d) {
				for (var i in list) {
					if (d.indexOf(i)!=-1) {
						name==''? name=list[i]:name+=','+list[i];
					}
				}
			}
			return name;
		},

		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		parent_f(name){
			var seller_type= this.editForm.seller_type;
			var zhi=false;
			if (seller_type&&seller_type.length>0) {
				for (var i = 0; i < seller_type.length; i++) {
					if (seller_type[i]==name) {
						zhi=true;
						break;
					}
				}
			}
			return zhi;
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 15px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/admin.vue